import { FC, useEffect, useState } from 'react'

// Components
import ConfirmationCompsWrapper from './ConfirmationCompsWrapper'

// Redux
import { useAppSelector } from '../../../../../../store/hooks'
import {
  selectFilteredPaperworkDocuments,
  selectPaperworkTabData,
} from '../../../../../../store/registration/registrationSlice'

import {
  IPaperworkAccordionTypeItem,
  IPayTab,
} from '../../../../../../models/event-registered-users/event-registered-users.interface'
import { IRegistrationEventTab } from '../../../../../../types/competitor_types'

import { CONST } from '../../../../../../const/const'

type SelectedEventPaperworkListProps = {
  setEventTab: (eventTab: IRegistrationEventTab) => void
}

export const SelectedEventPaperworkList: FC<SelectedEventPaperworkListProps> = ({
  setEventTab,
}) => {
  let filteredPaperworkDocuments = useAppSelector(selectFilteredPaperworkDocuments)
  const paperworkTabData = useAppSelector(selectPaperworkTabData)

  const [open, setOpen] = useState(false)
  const [selectedUnits, setSelectedUnits] = useState<IPaperworkAccordionTypeItem[]>([])

  useEffect(() => {
    let signTabPaperworkAccordion: IPayTab['paperwork']['data'] = []
    let index = -1
    let memberPreAdded = false
    const paperwork = paperworkTabData

    filteredPaperworkDocuments.forEach((currPaperworkDocument) => {
      index = signTabPaperworkAccordion.findIndex((curr) => curr.key === currPaperworkDocument.key)

      if (index === -1) {
        signTabPaperworkAccordion.push({
          signatories: [],
          signatoryCount: 0,
          key: currPaperworkDocument.key,
          documentName: currPaperworkDocument.document_name,
        })
        index = signTabPaperworkAccordion.length - 1
      }
    })

    filteredPaperworkDocuments.forEach((currPaperworkDocument) => {
      index = signTabPaperworkAccordion.findIndex((curr) => curr.key === currPaperworkDocument.key)

      if (index === -1) {
        signTabPaperworkAccordion.push({
          signatories: [],
          signatoryCount: 0,
          key: currPaperworkDocument.key,
          documentName: currPaperworkDocument.document_name,
        })
        index = signTabPaperworkAccordion.length - 1
      }

      paperwork.forEach((currPaperworkTabRow) => {
        currPaperworkTabRow.ridersTeamMembers.forEach((currRiderTeamMember) => {
          currRiderTeamMember.mailLog.forEach((currMailLog) => {
            if (currMailLog.paperworkKey === currPaperworkDocument.key) {
              memberPreAdded = !!(signTabPaperworkAccordion[index]?.signatories || []).find(
                (currSignatory) => {
                  return currSignatory.teamMemberId === currRiderTeamMember.teamMemberId
                }
              )

              signTabPaperworkAccordion[index] = {
                ...signTabPaperworkAccordion[index],
                signatories: signTabPaperworkAccordion[index]?.signatories || [],
              }

              if (!memberPreAdded) {
                signTabPaperworkAccordion[index].signatories.push({
                  teamMemberId: currRiderTeamMember.teamMemberId,
                  teamMemberName: currRiderTeamMember.teamMemberName,
                })
                signTabPaperworkAccordion[index].signatoryCount++
              }
            }
          })
        })
      })
    })
    setSelectedUnits(signTabPaperworkAccordion)
  }, [filteredPaperworkDocuments, paperworkTabData])

  let signatoriesCount = 0
  selectedUnits.forEach((unit) => (signatoriesCount += unit.signatoryCount))

  return (
    <ConfirmationCompsWrapper
      title="Paperwork"
      setEventTab={setEventTab}
      redirectTab={CONST.UI.REGISTER.TABS.PAPERWORK}
      accordion={{ open, setOpen }}
      selected_units={`${filteredPaperworkDocuments.length} docs, ${signatoriesCount ? 1 : 0} signer`}
      showList={!!selectedUnits.filter((item) => item.signatories?.[0]).length}
    >
      <div className="space-y-4 p-4">
        {selectedUnits.map((item, index) => (
          <div
            key={index}
            className="w-full p-4 bg-gray-50 hover:bg-gray-100 transition-colors rounded-lg border border-gray-200"
          >
            <p className="font-medium text-gray-900">
              <span>{item.documentName}</span>
            </p>
            <p className="text-sm text-gray-600">
              Signers:{' '}
              {!item.signatories?.[0]
                ? 'No signatories added'
                : item.signatories.map((currSignatory) => currSignatory.teamMemberName).join(', ')}
            </p>
          </div>
        ))}
      </div>
    </ConfirmationCompsWrapper>
  )
}
